export const TRANSLATION_GROUPS_OF_ADMINS_EDIT = Symbol('groups-of-admins-edit');
export const GROUPS_OF_ADMINS_EDIT_ROUTE_NAME = Symbol('groups-of-admins.edit');

export const OWNERS_LIST_QUERY_KEY = 'groups-of-admin-owner-edit-query';
export const OWNERS_LIST_QUERY_API_URL = 'admin/admin_groups/:id';

export const GROUPS_OF_ADMINS_EDIT_OWNER_MUTATION_KEY = 'groups-of-admin-owner-edit-mutation';
export const GROUPS_OF_ADMINS_EDIT_OWNER_MUTATION_API_URL = 'admin/admin_groups/:id';

export const AVAILABLE_ADMINS_LIST_QUERY_KEY = 'groups-of-admins-list-query';
export const AVAILABLE_ADMINS_LIST_QUERY_API_URL = 'admin/admin_groups/:id/available_admins';

export const GROUPS_OF_ADMINS_CHANGE_MUTATION_KEY = 'groups-of-admins-change-mutation';
export const GROUPS_OF_ADMINS_ADD_MUTATION_API_URL = 'admin/admin_groups/:id/add_admin';
export const GROUPS_OF_ADMINS_REMOVE_MUTATION_API_URL = 'admin/admin_groups/:id/remove_admin';
